export default __webpack_public_path__ + "static/media/stewart.878e96fe.webp";